import React from 'react';
import { iconPropTypes, iconDefaultProps } from '../iconPropTypes';

const TrendingIcon = ({ fill, width, height, ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
            <path d="M9.06472 0H13.963C14.322 0 14.6179 0.275772 14.6583 0.631053L14.6631 0.714362V5.71489C14.6631 6.10943 14.3496 6.42925 13.963 6.42925C13.6039 6.42925 13.3081 6.15351 13.2676 5.79819L13.2629 5.71489L13.2624 2.43883L8.15735 7.64874C7.90512 7.90613 7.50832 7.92606 7.23368 7.70853L7.16773 7.64917L5.56033 6.01185L1.85827 9.79068C1.58491 10.0697 1.14165 10.0698 0.868212 9.79083C0.615806 9.53337 0.59633 9.12818 0.809825 8.84787L0.868051 8.78058L5.06472 4.49691C5.31691 4.23945 5.71378 4.21945 5.98845 4.43704L6.05442 4.49641L7.66184 6.13379L12.2718 1.42872H9.06472C8.70572 1.42872 8.4098 1.15295 8.36941 0.79767L8.36465 0.714362C8.36465 0.348008 8.63495 0.0460692 8.98309 0.00480771L9.06472 0Z" fill={fill} />
        </svg >
    );
}

TrendingIcon.propTypes = iconPropTypes
TrendingIcon.defaultProps = iconDefaultProps

export default TrendingIcon;
